import { ShieldCheck } from "lucide-react";

export const STANDARD_FEATURES = {
  "Gator Trax": [
    ".125 thick hull",
    "15″ – 21″ sides",
    "Flotation (optional on hulls over 20′ length)",
    "Standard navigation lights",
    "False floor",
    "Grab bar",
    "Rear storage box / driver’s seat",
    "Front deck",
    "Gator Boat Brown paint",
  ],
  "Pro-Drive": [
    "Base brown paint",
    "Seat box",
    "Multi-box",
    "Gunnel switch box",
    "Removable grab bar",
    "Battery + battery box",
    "14-gallon aluminum fuel tank",
    "120W LED light bar",
    "Interior LED strips (you pick the color)",
    "Rooster tail lights (you pick the color)",
    "Spotlight plug on the deck, wired to the switch panel",
    "Trolling motor plugs",
    "Spud pole kit",
    "Three battery trays",
  ],
};

export const StandardFeatures = ({ brand, className = "" }) => {
  const items = STANDARD_FEATURES[brand];
  if (!items) return null;
  return (
    <div className={`rounded-lg border border-border bg-card p-5 ${className}`} data-testid="standard-features-box">
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
        <ShieldCheck size={15} className="text-[#1B66C9]" /> Standard features
      </p>
      <p className="mt-1 text-[11px] text-muted-foreground">Included on every {brand} hull — no extra charge.</p>
      <ul className="mt-3 space-y-1.5 text-sm">
        {items.map((f) => (
          <li key={f} className="flex items-start gap-2">
            <span className="mt-[7px] h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#1B66C9]" />
            <span>{f}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
